<template>
  <div>

    <div class="container-fluid px-0">
      <HeaderView :imgHeader="infoHeader.img " :dataHeader="infoHeader.TextHeader"></HeaderView>

      <div class="bg-light py-5 ">

        <div  class="py-3">
          <div class="bg-card rounded border card-center p-4 shadow ">
            <b-form style="width: 100% !important;" class="  " @submit.prevent="login()">
              <div >
                <div class="mb-2">
                  <div class="title-left " >
                    <h2 class="  mb-0">{{ $t('auth.loginTitle') }}</h2>
                  </div>
                </div>
                <div class="  mt-5">

                  <div class=" form-group-line  "  >
                    <i class="fa-solid fa-user"></i>
                    <input v-model="row.Usuario" required type="text"  id="exampleInputPassword1" :placeholder="$t('auth.username')" />
                  </div>
                </div>
                <div class="  mt-3">
                  <div class="  "    >
                    <div class="form-group-line ">
                      <i class="fa-solid fa-lock"></i>
                      <input v-model="row.Password" required :type="(pass==true ? 'text' : 'password')" class="form-control" id="exampleInputPassword1" :placeholder="$t('auth.password')" />
                      <i @click="pass = !pass" :class="(pass==true ? 'fa-eye-slash' : 'fa-eye')" class="fa-solid icon-right pointer"></i>

                    </div>

                    <div class="px-xl-3">
                      <span class="text-secondary ">{{ $t('auth.passwordHint') }}</span>
                    </div>
                  </div>
                </div>

                <div class="mt-3 d-none d-sm-block">
                  <div class="py-2 d-flex">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="status"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                    >
                      {{ $t('auth.rememberMe') }}
                    </b-form-checkbox>
                    <a class="  pointer ml-auto mt-1" @click="$router.push('/recuperar_pass')">{{ $t('auth.forgotPassword') }}</a>
                  </div>
                  <button type="submit"   class="btn   btn-primary btn-pill mb-2 ">{{ $t('auth.login') }}</button>
                  <button @click="$router.push('/registro')"  class="btn   btn-light-secondary btn-pill mb-2  ml-xl-2">{{ $t('auth.createAccount') }}</button>
                </div>
                <div class="d-md-none  ">
                  <div class="py-2  ">
                    <b-form-checkbox
                    class="mb-3"
                      id="checkbox-1"
                      v-model="status"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                    >
                      {{ $t('auth.rememberMe') }}
                    </b-form-checkbox>
                    <a class="  pointer " @click="$router.push('/recuperar_pass')">{{ $t('auth.forgotPassword') }}</a>
                  </div>
                  <button type="submit"   class="btn btn-block  btn-primary btn-pill mb-2 ">{{ $t('auth.login') }}</button>
                  <button @click="$router.push('/registro')"   class="btn btn-block  btn-light-secondary btn-pill mb-2  ml-xl-2">{{ $t('auth.createAccount') }}</button>
                </div>

              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from "../components/HeaderView.vue";
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";

// admin@mecatestudio.com
// 123456
export default {
  components: { HeaderView },
  data: () => ({
    pass:false,
    infoHeader:{
      img: 'https://sheltos-vue.vercel.app/image/3.jpg',
      TextHeader: ''
    },
    registro: false,
    email: "",
    row: {
      Usuario: "",
      Password: ""
    },
  }),
  created() {
    this.infoHeader.TextHeader = this.$t('auth.loginTitle');
  },
  mounted() {
    // if(this.$store.state.user!=null){
    //   this.$router.push({name: 'Checkout'});
    // }
  },
  methods: {
    resolvePublicDomain() {
      return resolveStoredPublicDomain(this.$domain);
    },
    async recoverPassword() {
      if (this.email == "") {
        this.$swal({
          icon: "error",
          title: this.$t('common.errorTitle'),
          text: this.$t('auth.recoverEmailRequired'),
        });
        return;
      }
      const data = {
        mail: this.email,
      };
      const recoverPass = await this.$store.dispatch("saveNew", {
        table: "recoverPassword",
        data,
      });
      this.$bvModal.hide("modal-recoverPassword");
      this.email = "";
      this.$swal({
        icon: "success",
        title: this.$t('common.successTitle'),
        text: this.$t('auth.recoverEmailSent'),
      });
    },
    async login() {
      // let user={
      //   status: 1,
      //   address:'Calle la for NÂº25',
      //   phone: '505-55698785',
      //   nit: '12321-2121123',
      //   customerName:'Jos? P?rez',
      //   rol: 1
      // }
      try {
        this.$isLoading(true);
        const resolvedDomain = this.resolvePublicDomain();
        const loginPayload = {
          username: this.row.Usuario,
          password: this.row.Password,
          domain: resolvedDomain,
          isPublic: false,
          Usuario: this.row.Usuario,
          Password: this.row.Password,
          Dominio: resolvedDomain,
        };
        let req = await this.$store.dispatch("login", { data: loginPayload });
        this.$isLoading(false);

        if (req) {
          this.$router.push("/");
        } else {
          this.$swal({
            icon: "error",
            title: this.$t('common.errorTitle'),
            text: this.$t('auth.errorUserPending'),
          });
        }
      } catch (error) {
        this.$isLoading(false);
        this.$swal({
          icon: "error",
          title: this.$t('common.errorTitle'),
          text: this.$t('auth.errorCredentials'),
        });
        console.error(error);
      }
    },
  },
};
</script>

<style>

</style>

